import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function SingleUserLimitDialog({ open, handleClose }) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      maxWidth="xl"
      PaperProps={{
        sx: !isMobile
          ? { width: "50%", padding: "20px " }
          : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
      }}
      // Keep the same behavior as your AddModal (no click-outside close)
      disableEscapeKeyDown
    >
      {/* Make the whole BACK row clickable */}
      <Box
        onClick={handleClose}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleClose();
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          width: "fit-content",
          mb: 1,
        }}
      >
        <IconButton onClick={handleClose}>
          <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
        </IconButton>

        <Typography variant="subtitle3">
          {t("back")}
        </Typography>
      </Box>

      <DialogTitle mb={3}>
        <Typography variant="title4">{t("add_user")}</Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="subtitle2">
          Your account is limited to one user.
        </Typography>
      </DialogContent>

    </Dialog>
  );
}